import { Action, ButtonV2, CopyButton, HeroCentered, LinkButton } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes extends React.ComponentProps<typeof HeroCentered>, ICTAAttributes {
  imageLeftId: number
  imageRightId: number
  imageMobileId: number

  displayCoupon: boolean
  afterCopyText: string
  couponCode: string
  couponRightButtonTitle: string
  couponRightButtonLink: string
  couponSublabel: string
  couponButtonClassName: string
  actionButtonClassName: string
}

const HeroCenteredBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const { callToAction, secondaryCallToAction } = useCTAAttributes(attributes)

  const renderCouponLinks = () => {
    if (attributes.displayCoupon) {
      return (
        <Action
          align="center"
          reverseOnMobile
          sublabel={attributes.couponSublabel}
          sublabelColor="dark"
          leftButton={
            attributes.couponCode ? (
              <CopyButton
                copyText={attributes.afterCopyText}
                variant="copy"
                buttonProps={{
                  icon: 'copy',
                  className: attributes.couponButtonClassName,
                }}
              >
                {attributes.couponCode}
              </CopyButton>
            ) : null
          }
          rightButton={
            attributes.couponRightButtonTitle ? (
              <ButtonV2
                as="a"
                variant="primary"
                color="primary"
                size="medium"
                href={attributes.couponRightButtonLink}
                className={attributes.actionButtonClassName}
              >
                {attributes.couponRightButtonTitle}
              </ButtonV2>
            ) : null
          }
        />
      )
    }
    return null
  }

  return (
    <HeroCentered
      {...attributes}
      leftRightButtonsOverride={renderCouponLinks()}
      leftButton={
        callToAction ? (
          <LinkButton
            {...callToAction}
            href={callToAction.url}
            type="primary"
            fullWidth={{ default: true, tablet: false }}
            size="large"
          >
            {callToAction.text}
          </LinkButton>
        ) : null
      }
      rightButton={
        secondaryCallToAction ? (
          <LinkButton
            {...secondaryCallToAction}
            href={secondaryCallToAction.url}
            type="secondary"
            fullWidth={{ default: true, tablet: false }}
            size="large"
          >
            {secondaryCallToAction.text}
          </LinkButton>
        ) : null
      }
    />
  )
}

export default HeroCenteredBlock
